import {integrationTypeMap} from '../constants';

export const getIntegrationTypeStringValue = (integrationType: number) => integrationTypeMap[integrationType];
